module.exports = __webpack_public_path__ + "img/ticket.a3834275.svg";